<script setup>
import { onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useTabStore } from "@/stores/tabStore";
import { fetchCsrfToken } from "@/utils/request";
import { ElMessage } from "element-plus";
const route = useRoute();
const whitePath = ["/login", "/"];

const tabStore = useTabStore();

// 在组件挂载时获取 CSRF 令牌
onMounted(async () => {
  try {
    // 应用启动时获取 CSRF token
    if (!localStorage.getItem("csrf_token")) {
      await fetchCsrfToken();
    }
  } catch (error) {
    // console.warn("Initial CSRF token fetch failed:", error);
    ElMessage.warning("CSRF令牌初始化失败，部分功能可能受限");
  }
});
watch(
  route,
  (to) => {
    if (whitePath.indexOf(to.path) === -1) {
      const obj = {
        name: to.name,
        path: to.path,
      };
      tabStore.addTabs(obj);
    }
  },
  { deep: true, immediate: true }
);

watch(
  route,
  (to) => {
    if (to.name === "个人中心") {
      const obj = {
        name: to.name,
        path: to.path,
      };
      tabStore.addTabs(obj);
    }
  },
  { deep: true, immediate: true }
);
</script>

<template>
  <router-view />
</template>

<style>
html,
body,
#app {
  height: 100%;
}
.app-container {
  padding: 20px;
}
</style>
